__turbopack_context__.v({
  "HeroWrapper": "w0VMcW_HeroWrapper",
  "Root": "w0VMcW_Root",
});
